import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import { useAuth } from '../../contexts/AuthContext';

const TabNavigation = () => {
  const navigate = useNavigate();
  const { signOut, isAuthenticated } = useAuth();

  const navigationItems = [
    {
      label: 'Calendar',
      path: '/calendar-view',
      icon: 'Calendar',
      tooltip: 'View and manage your weekly schedule'
    },
    {
      label: 'Bookings',
      path: '/booking-management',
      icon: 'Clock',
      tooltip: 'Create and edit appointments'
    },
    {
      label: 'Customers',
      path: '/customer-database',
      icon: 'Users',
      tooltip: 'Manage customer information'
    },
    {
      label: 'Services',
      path: '/service-management',
      icon: 'Briefcase',
      tooltip: 'Manage service types and pricing'
    }
  ];

  const handleLogout = async () => {
    const { error } = await signOut();
    if (!error) {
      navigate('/login');
    }
  };

  return (
    <>
      <nav className="hidden lg:block bg-card border-b border-border shadow-elevation-1">
        <div className="max-w-7xl mx-auto px-8">
          <div className="flex items-center space-x-8">
            <div className="flex items-center py-4">
              <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-lg">
                <Icon name="CalendarDays" size={28} color="var(--color-primary)" />
              </div>
              <span className="ml-3 text-xl font-heading font-semibold text-foreground">
                BookingCalendar
              </span>
            </div>
            <div className="flex space-x-2 flex-1">
              {navigationItems?.map((item) => (
                <NavLink
                  key={item?.path}
                  to={item?.path}
                  title={item?.tooltip}
                  className={({ isActive }) =>
                    `flex items-center px-6 py-4 text-sm font-medium transition-smooth border-b-2 ${
                      isActive
                        ? 'border-primary text-primary' :'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
                    }`
                  }
                >
                  <Icon name={item?.icon} size={20} className="mr-2" />
                  <span>{item?.label}</span>
                </NavLink>
              ))}
            </div>
            {isAuthenticated && (
              <button
                onClick={handleLogout}
                className="flex items-center px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-smooth border border-border rounded-lg hover:bg-accent"
                title="Sign out"
              >
                <Icon name="LogOut" size={20} className="mr-2" />
                <span>Logout</span>
              </button>
            )}
          </div>
        </div>
      </nav>
      <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-card border-t border-border shadow-elevation-3 z-navigation">
        <div className="flex justify-around items-center h-16">
          {navigationItems?.map((item) => (
            <NavLink
              key={item?.path}
              to={item?.path}
              title={item?.tooltip}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center flex-1 h-full transition-smooth ${
                  isActive
                    ? 'text-primary' :'text-muted-foreground active:scale-97'
                }`
              }
            >
              <Icon name={item?.icon} size={24} />
              <span className="text-xs font-caption mt-1">{item?.label}</span>
            </NavLink>
          ))}
          {isAuthenticated && (
            <button
              onClick={handleLogout}
              className="flex flex-col items-center justify-center flex-1 h-full transition-smooth text-muted-foreground active:scale-97"
              title="Sign out"
            >
              <Icon name="LogOut" size={24} />
              <span className="text-xs font-caption mt-1">Logout</span>
            </button>
          )}
        </div>
      </nav>
    </>
  );
};

export default TabNavigation;